import { Camera, Shield, Zap, Home, Lock, Square } from "lucide-react";

export const PARKING_FACILITIES = [
  ["camera", "Camera", <Camera size={12} key="c" />],
  ["security_24_7", "24/7 security", <Shield size={12} key="s" />],
  ["ev_charging", "EV charging", <Zap size={12} key="z" />],
  ["covered_roof", "Covered roof", <Home size={12} key="r" />],
  ["gated", "Gated", <Lock size={12} key="g" />],
  ["fenced", "Fenced", <Square size={12} key="f" />],
];

export const PARKING_SPACE_TYPES = [
  ["driveway", "Driveway"],
  ["garage", "Garage"],
  ["street", "Street"],
  ["underground", "Underground"],
  ["carport", "Carport"],
  ["ev_bay", "EV bay"],
  ["reserved_spot", "Reserved spot"],
  ["commercial_lot", "Commercial lot"],
];

export const EDITABLE_PARKING_STATUSES = new Set(["pending", "approved", "paused", "rejected"]);

export const HHMM_RE = /^([01]\d|2[0-3]):[0-5]\d$/;

/** Client-side validation for open_time / close_time before submit. */
export function validateParkingHours(form) {
  if (form.open_24_7) return null;
  if (!HHMM_RE.test(String(form.open_time || "").trim())) {
    return "Enter open time as HH:MM (e.g. 08:00)";
  }
  if (!HHMM_RE.test(String(form.close_time || "").trim())) {
    return "Enter close time as HH:MM (e.g. 22:00)";
  }
  return null;
}

export function buildParkingPayload(form, images) {
  return {
    name: form.name,
    address: form.address,
    city: form.city,
    space_type: form.space_type,
    price_per_hour: parseFloat(form.price_per_hour),
    max_hours: form.max_hours !== "" && form.max_hours != null ? parseInt(form.max_hours, 10) : null,
    open_24_7: !!form.open_24_7,
    open_time: form.open_24_7 ? null : (form.open_time || null),
    close_time: form.open_24_7 ? null : (form.close_time || null),
    facilities: form.facilities || [],
    description: form.description || "",
    images: images || form.images || [],
  };
}
